import React, { useRef } from 'react';

const PrenatalHistoryForm: React.FC = () => {
  const formRef = useRef<HTMLFormElement>(null);
  const clear = () => formRef.current?.reset();

  const questions = [
    'Bleeding or Spotting',
    'German Measles (Rubella)',
    'Gestational Diabetes',
    'High Blood Pressure',
    'Illness other than Cold / Flu',
    'Kidney Disease',
    'Premature Labor',
    'Threatened Miscarriage',
    'Toxemia',
  ];

  return (
    <form ref={formRef} className="family-form">
      <div className="section-title">While pregnant, did mother have:</div>
      <div className="yesno-list one">
        {questions.map((q, i) => (
          <div key={q} className="yesno-item">
            <span className="lbl">{i + 1}. {q}</span>
            <label><input type="radio" name={`prenatal-${i+1}`} /> Yes</label>
            <label><input type="radio" name={`prenatal-${i+1}`} /> No</label>
          </div>
        ))}
      </div>

      <div className="yesno-list one" style={{marginTop: 8}}>
        <div className="yesno-item">
          <span className="lbl">Were medications or herbs taken during pregnancy?</span>
          <label><input type="radio" name="prenatal-meds" /> Yes</label>
          <label><input type="radio" name="prenatal-meds" /> No</label>
        </div>
        <div className="yesno-item">
          <span className="lbl">Was a fertility treatment used for this pregnancy?</span>
          <label><input type="radio" name="prenatal-fertility" /> Yes</label>
          <label><input type="radio" name="prenatal-fertility" /> No</label>
        </div>
      </div>

      <div className="form-actions">
        <button type="button" className="btn-clear" onClick={clear}>Clear</button>
      </div>
    </form>
  );
};

export default PrenatalHistoryForm;


